export const CONFIGURATIONS_SHIPPING_BOX_MODAL_EVENT = 'configurations:modals:shipping-box';
export const CONFIGURATIONS_SHIPPING_BOX_MODAL_OPEN = `${CONFIGURATIONS_SHIPPING_BOX_MODAL_EVENT}:open`;
export const CONFIGURATIONS_SHIPPING_BOX_MODAL_CLOSE = `${CONFIGURATIONS_SHIPPING_BOX_MODAL_EVENT}:close`;
